var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"web__loader"},[_c('b-spinner'),_c('p',[_vm._v("Creando, no recarges la pagina")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }